import React, { Component } from "react";
import LocationTracking from "../../components/location-tracking";

class LocationTrackingPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      translate,
      languages,
      roles
    } = this.props;

    return (
      <LocationTracking
        translate={translate}
        languages={languages}
        roles={roles}
      />
    );
  }
}

export default LocationTrackingPage;
